/** Prefer `message`, fall back to legacy typo `mesasge`. */
export function apiMessage(data, fallback = "Something went wrong") {
  if (typeof data === "string" && data.trim()) return data;
  return data?.message || data?.mesasge || fallback;
}

export function listFailureMessage(status, serverMessage, resource = "this page") {
  if (!status) return "We can't reach the server. Check your connection and try again.";
  if (status === 401) return "Your session has expired. Please sign in again.";
  if (status === 403) return `You don't have permission to view ${resource}.`;
  if (serverMessage && serverMessage !== "Internal server error") return serverMessage;
  return `We couldn't load ${resource}. Please try again.`;
}

/** Sign-in failures: show server text when present; reserve "connect" wording for true network faults. */
export function loginFailureMessage(err) {
	const data = err?.response?.data;
	if (err?.response) {
		const status = err.response.status;
		if (status === 429) {
			return "Too many sign-in attempts. Please wait a minute and try again.";
		}
		if (status >= 500) {
			return "We're having trouble on our side. Please try again in a moment.";
		}
		return apiMessage(data, "Sign in failed. Check your email and password.");
	}
	if (err?.code === "ECONNABORTED") {
		return "That took too long. Please try again.";
	}
	const msg = String(err?.message || "");
	if (/network error/i.test(msg)) {
		return "We can't reach the server. Check your connection and try again.";
	}
	return "We can't reach the server. Check your connection and try again.";
}

const seen = new Map();

export function shouldShowToast(key, now = Date.now(), windowMs = 4000) {
  const previous = seen.get(key);
  if (previous && now - previous < windowMs) return false;
  seen.set(key, now);
  return true;
}

export function resetToastDedupe() {
  seen.clear();
}
